/**
 * Log given exception as error.
 * This should be used when unexpected errors can be caught in a try/catch
 */
export const logException = (exception: unknown) => {
    if (!exception) {
        return;
    }

    // eslint-disable-next-line no-console
    console.error(exception);
};
